module.exports = __webpack_public_path__ + "img/logo6.c8675a51.png";